import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { gameplayTypeConfigAll } from "@/api/config";
export var gameplayType = {
  namespaced: true,
  state: {
    isInit: 0,
    gameplayTypeKv: {}
  },
  mutations: {
    setGameplayTypeKv: function setGameplayTypeKv(state, gameplayTypeMap) {
      state.isInit = 1;
      state.gameplayTypeKv = gameplayTypeMap;
    }
  },
  actions: {
    getGameplayType: function getGameplayType(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, gameplayTypeMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return gameplayTypeConfigAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                gameplayTypeMap = {};
                res.data.forEach(function (val) {
                  gameplayTypeMap[val.gameplay_type_id] = val.gameplay_type_name;
                });
                commit("setGameplayTypeKv", gameplayTypeMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    gameplayTypeMap: function gameplayTypeMap(state) {
      return state.gameplayTypeKv;
    }
  }
};